<template>
  <transition
    v-if="shouldDisplay"
    enter-class="h-0 opacity-0"
    enter-active-class="transition duration-200 ease-out transform"
    enter-to-class="opacity-100"
    leave-class="opacity-100"
    leave-active-class="transition duration-200 ease-in transform"
    leave-to-class="h-0 opacity-0"
  >
    <section v-show="isOpen" class="bg-app-secondary-4-yellow--light-portica text-xs text-black font-semibold px-4 py-2">
      <div class="flex items-start justify-between xl:px-24 2xl:px-[8vw]">
        <div class="flex items-start">
          <AtomIconBell class="w-4 inline shrink-0 mr-2" />
          <div class="c-notification-message-text">
            <span v-html="message.message" />
            <AtomLink v-if="message.buttonUrl && message.buttonLabel" :url="message.buttonUrl" class="font-semibold underline">{{ message.buttonLabel }}</AtomLink>
          </div>
        </div>
        <div class="group w-12 cursor-pointer flex shrink-0 items-start justify-end lg:mr-5 xl:mr-0" @click="isOpen = !isOpen">
          <AtomIconX class="c-notification-close-button group-hover:text-app-primary-1-orange--bittersweet transform transition duration-200 w-3 shrink-0" />
        </div>
      </div>
    </section>
  </transition>
</template>

<script setup lang="ts">
const props = defineProps({
  // Defaults to an empty object: the template reads `message.message` unguarded, and the only caller
  // passes a CMS value that is absent whenever no notification is configured.
  message: { type: Object as PropType<Record<string, any>>, required: false, default: () => ({}) },
  open: { type: Boolean, required: false, default: true },
})

const isOpen = ref(props.open)
const shouldDisplay = computed(() => {
  // Check if there is anything to display
  if (!props.message?.message) {
    return false
  }

  const startDate = props.message?.startDate ? new Date(props.message.startDate) : undefined
  const endDate = props.message?.endDate ? new Date(props.message.endDate) : undefined
  const currentDate = new Date()

  // Filter based on optional startDate
  if (startDate && currentDate < startDate) {
    return false
  }

  // Filter based on optional endDate
  if (endDate && currentDate > endDate) {
    return false
  }

  return true
})
</script>

<style lang="scss">
// scoped scss is NOT suitable for this component, it won't work in this case because it needs to inherit styles from parent elements

.c-notification-message-text {
  p {
    @apply inline; // This way the additional button in the notification will appear next to the rendered paragraph.
  }

  a {
    @apply cursor-pointer underline transform transition duration-200;

    &:hover {
      text-decoration-thickness: 2px;
    }
  }
}

.c-notification-close-button {
  margin-top: 2px; // for alignment when the notification is very short and only one line
}
</style>
